<div class="h-full w-full">
  <div class="w-full aligner-between h-[50px] px-3">
    <div class="text-standard-heading ont-semibold text-gray-800 flex items-center">
      Resolve {{ state.conflictType ? (state.conflictType | titlecase) + ' ' : '' }}conflicts &nbsp;<fa-icon
        class="text-red-600"
        [icon]="['fal', 'exclamation-triangle']"
      ></fa-icon>
      <mat-spinner
        *ngIf="committing$ | async"
        [color]="'primary'"
        class="inline-block spinner ml-2"
        [diameter]="22"
      ></mat-spinner>
    </div>
  </div>
  <div class="h-[40px] pt-0 pl-3">
    <mat-button-toggle-group [formControl]="mergeModeFC" class="toggle-group-deep-style">
      <mat-button-toggle [value]="'simple'"> Simple merge </mat-button-toggle>
      <mat-button-toggle [value]="'vscode'"> VSCode 3 way merge </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div style="height: calc(100% - 90px)">
    <ng-container !state.loading.conflicts>
      <as-split *ngIf="mergeModeFC.value !== 'vscode'" [useTransition]="true" [gutterSize]="6">
        <as-split-area [size]="45" class="h-full w-full relative">
          <y42-git-diff-tree
            class="block h-full border-common"
            [changes]="state.conflicts"
            [activeItem]="activeConflict"
            (activeItemChange)="selectActiveConflict($event)"
            (selectedItemsChange)="selectedConflicts = $event"
          ></y42-git-diff-tree>
        </as-split-area>

        <as-split-area [size]="55" class="h-full w-full relative flex flex-col">
          <ng-container *ngIf="activeConflict">
            <div class="flex flex-1">
              <ng-container *ngIf="mergeModeFC.value === 'simple'">
                <div
                  class="merge-editor h-full flex-1"
                  [style.paddingTop.px]="25"
                  y42MonacoDiffEditor
                  [fileName]="activeConflict.path"
                  [original]="activeConflict.yours"
                  [modified]="activeConflict.theirs"
                ></div>
                <div class="pl-2 pr-2 w-[160px]">
                  <y42-smart-btn
                    type="button"
                    class="mt-1 w-full mb-2"
                    [class]="'bg-green-100 text-green-700'"
                    [pending]="state.resolving === 'yours'"
                    [disabled]="!selectedConflicts.length"
                    [style]="'dark'"
                    (click)="resolveConflict('yours')"
                  >
                    {{ state.resolving === 'yours' ? 'Resolving...' : 'Accept Yours' }}
                  </y42-smart-btn>
                  <y42-smart-btn
                    type="button"
                    class="w-full"
                    [class]="'bg-red-100 text-red-600'"
                    [pending]="state.resolving === 'theirs'"
                    [disabled]="!selectedConflicts.length"
                    [style]="'dark'"
                    (click)="resolveConflict('theirs')"
                  >
                    {{ state.resolving === 'theirs' ? 'Resolving...' : 'Accept Theirs' }}
                  </y42-smart-btn>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </as-split-area>
      </as-split>

      <y42-vscode-editor
        *ngIf="state.conflicts && mergeModeFC.value === 'vscode'"
        [openMergeEditor]="true"
        (completeMerge)="completeMerge()"
      ></y42-vscode-editor>
    </ng-container>

    <y42-logo-loader *ngIf="state.loading.conflicts" class="center-absolute" [widthInPixel]="70"> </y42-logo-loader>
  </div>
</div>
